import * as React from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useSetRecoilState, useRecoilValue } from 'recoil';
import { Level } from '../../atom/atom';



export default function LevelSelect(props) {
  var mySettings = props.settings
  const setLevel = useSetRecoilState(Level)
  const level = useRecoilValue(Level)

  const handleChange = (event) => {
    setLevel(event.target.value);
  };

  return (
    <Box sx={{ p: "16px" }} >
      <FormControl>
        <Select
          labelId="demo-simple-select-label"
          id="demo-select-small"
          value={level}
          label="School Level"
          onChange={handleChange}
          variant='standard'
        >
          <MenuItem value={'es'}>Elementary School</MenuItem>
          <MenuItem value={'ms'}>Middle School</MenuItem>
          <MenuItem value={'hs'}>High School</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
